// Components
import { Button } from "reactstrap"

// Icons
import { FiX } from "react-icons/fi"

export const CloseButton = ({ onClick }) => (
    <Button
        color='flat-danger'
        size='sm'
        onClick={onClick}
        className="p-0"
    >
        <FiX size={18} className="text-danger" />
    </Button>
)